import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { startPayment, isPaymentFormError } from "../../../api/payment";
import useModal from "../../../helpers/useModal";
import { styled } from "../../../stitches.config";
import { PaymentParams, PaymentStatus, PaymentType } from "../../types/Payment";
import TipModal from "./TipModal";
import CollectionTileModal from "./CollectionTileModal";
import axios from "axios";

const PaymentModal = () => {
  const { modalData } = useModal();
  const navigate = useNavigate();
  const currentLocation = useLocation();

  const [activeRequest, setActiveRequest] = React.useState(false)
  const [urlBlikStatus, setUrlBlikStatus] = React.useState("")
  const [checkedBlikStatus, setCheckedBlikStatus] = React.useState(false)
  const fetchUrl = `${window.API_HOST}/api/payment/check-success?token=${urlBlikStatus}`;
  //const fetchUrl = `https://natemat-staging.jadwiga.easysoftware.pl/api/payment/check-success?token=A3FCF09B85-CB2285-DC6B33-3F6FF855E7`;

  const changeStatus = (
    newStatus: PaymentStatus,
    location: ReturnType<typeof useLocation>
  ) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete(PaymentParams.PAYMENT_STATUS);
    searchParams.set(PaymentParams.PAYMENT_STATUS, newStatus);
    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  const onPayButtonClick = async (
    amount: number,
    email: string,
    blikPay: boolean,
    message?: string,
    //name?: string,
    blikCode?: string,
  ) => {

    const payload = {
      amount: amount,
      termsAndCondition: true,
      blikPay: blikPay,
      blikCode: blikCode,
      message: message,
      //name: name,
      email: email,
      User_OID: modalData?.paymentEditorId,
      articleId: modalData?.paymentArticleId,
      origin: modalData?.paymentOrigin || "unknown"
    };

    if (modalData?.paymentType) {
      try {
        const paymentResponseData = await startPayment(payload, PaymentType[modalData.paymentType]);

        setUrlBlikStatus(paymentResponseData.token)
        setActiveRequest(true)

        changeStatus(PaymentStatus.WAITING, currentLocation);
      } catch (error) {
        if (isPaymentFormError(error))
          throw error;

        changeStatus(PaymentStatus.FAILED, currentLocation);
      }
    }
  };

  useEffect(() => {

    if (activeRequest) {
      const getStatus = function () {
        fetch(fetchUrl)
          .then(result => result.json())
          .then(result => setCheckedBlikStatus(result))
        console.log("test timer 2")
      }
      getStatus()
      const interval = setInterval(() => getStatus(), 2000)
      return () => {
        clearInterval(interval);
      }
    }
  }, [activeRequest])

  useEffect(() => {
    console.log("test url: ", fetchUrl)
    console.log("test url boolean: ", checkedBlikStatus)

    if (checkedBlikStatus) {
      changeStatus(PaymentStatus.SUCCESS, currentLocation);
      setActiveRequest(false)
    }
  }, [urlBlikStatus, checkedBlikStatus])


  const getModalContentByType = () => {
    switch (modalData?.paymentType) {
      case PaymentType.TIP: {
        return <TipModal onPayButtonClick={onPayButtonClick} />;
      }
        break;
      case PaymentType.BRID: {
        // return <BridPayment />
        return <CollectionTileModal onPayButtonClick={onPayButtonClick} />;
      }
    }
  };

  return <TipWrapper>{getModalContentByType()}</TipWrapper>;
};

export default PaymentModal;

const TipWrapper = styled("div", {
  height: "100%",
  overflowY: "auto",
  "@bp4": {
    height: "initial",
    overflowY: "initial",
  },
});
